import { Navigate } from 'react-router-dom';
import LoadingScreen from '../components/loading-screen/LoadingScreen';
import { useGetRTKQListingsQuery } from '../redux/rtkQuery/apiSlice';
import { PATH_HOME } from './paths';

// ----------------------------------------------------------------------

type ManagedOwnerCaseRouteProps = {
  children: React.ReactNode;
};

/** Only owners with at least one listing may access Cases. Uses the listings query so we do not redirect before load completes. */
export default function ManagedOwnerCaseRoute({ children }: ManagedOwnerCaseRouteProps) {
  const { isSuccess, isError, data } = useGetRTKQListingsQuery({});

  if (isError) {
    return <Navigate to={PATH_HOME.general.app} replace />;
  }
  if (!isSuccess) {
    return <LoadingScreen />;
  }
  if (data && data.length > 0) {
    return <>{children}</>;
  }
  return <Navigate to={PATH_HOME.general.app} replace />;
}
